import { object, string } from 'yup';
export const InviteUserFormSchema = object().shape({
    email: string().trim().email().required(),
    role: string().required(),
});
